<template>
  <button :variant="variant"
          :size="size"
          :outline="outline"
          :disabled="disabled"
          @click="$emit('click')">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "EsgBaseButton",
  props: {
    size: {
      type: String,
      default: 'md'
    },
    variant: {
      type: String,
      default: 'tertiary'
    },
    outline: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
  }
}
</script>

<style scoped>
button {
  padding: 10px 20px;
  width: auto;
  min-width: 100px;
  background-color: #747480;
  color: #FFF;
  border-color: transparent;
  font-size: 14px;
  font-weight: 500;
  font-family: 'NanumGothic', serif;
  border-radius: 10px;
  line-height: 150%;
}

button:focus {
  box-shadow: unset;
}

button[variant='primary'] {
  background-color: #2E2E38;
  color: #FFE600;
  border-color: transparent;
}

button[variant='primary']:hover,
button[variant='primary']:active,
button[variant='primary']:focus {
  color: #FFE600 !important;
  background-color: #0D0D17 !important;
  border-color: transparent !important;
  box-shadow: unset;
}

button[variant='primary'].disabled,
button[variant='primary']:disabled {
  color: #9C9CA8 !important;
  background-color: #C4C4CD !important;
  border-color: transparent;
}

button[variant='secondary'] {
  border-radius: 10px;
  background: #747480;
  color: #fff;
}

button[variant='secondary']:hover {
  background-color: #565662;
}

button.disabled,
button:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

button[variant='tertiary'] {
  height: 60px;
  background-color: #2E2E38;
  border: none;
  color: #FFF;
}

button[variant='tertiary']:hover {
  background-color: #0D0D17;
}

/* outline */
button[outline='true'] {
  border: none;
}

/* size */
button[size='lg'] {
  height: 60px;
}

button[size='md'] {
  height: 50px;
  padding: 10px 20px;
  font-size: 16px;
}

button[size='sm'] {
  height: 40px;
  padding: 8px 18px;
  font-size: 14px;
}

button[size='xs'] {
  height: 30px;
  padding: 5px 20px;
  font-size: 12px;
}
</style>